/*============================================================================
Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart() { 
$cart = $("#cart");
$.ajax({
  url: '/cart.js',
  dataType: 'json',
  type: 'post',
  data: $cart.serialize(),
  success: function (data) { 
    //alert('1');
	refreshCart(data);
  }
});
}

function refreshCart(cart) { 
    $cartBtn = $("#CartCount span");
   
    if ($cartBtn) {  
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      
      //alert(shopCurrency);
      
      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();
      
      if (cart.item_count > 3) { 
        $("#added-box ul").addClass("scrollUl");
      } else {
          $("#added-box ul").addClass("scrollUl");
      }
      
      
      if (cart.item_count <= 0) { 
        $cart.html('');
        $cart.append("<li class='empty_cart'>Your bag is empty</li>");                                         
        $(".cart-button").removeClass('itemincart');             
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">' + cart.item_count + '</a>');
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));    
        $(".addbag_count").hide();
        
      } else { 
        $("#added-box ul").removeClass("emptyUl");
        $.each(cart.items, function(index, item) {
          cart_items_html += '';
          cart_items_html += '<li class="cart_item last_cart_item">' +
			 '<div class="cart_image">' +
             '<img src="' + item.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" style="width:100%" />' +
             '</div>' +
			 '<div class="cart_item_right">' +
			 '<div class="item_title cart_item_title">' + item.title + '</div>' +
             '<div class="price item_price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</div>' +
			 /*'<div class="provar">' +
			 '<div>' + item.variant_title + '</div>' +
             '</div>' +*/
 			 '<div class="bottom_wrapper">' +
			 '<div class="mm-counter cart-quantity">' +
             /*'<span class="quantity-count minus ss-icon minus">&#x002D;</span>' +*/
             '<span>Qty:</span> <input type="text" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />' +
             /*'<span class="quantity-count plus ss-icon plus">&#x002B;</span>' +*/
             '</div>' +
             '<div class="removelink">' +
			 '<a href="javascript:void(0)" class="removelink_del" onclick="remove_item(' + item.variant_id + '); return false;">Remove</a>' +
			 '</div>' +
			 '</div>' +
			 '</div>' +
			 '</li>' ; 
			 /*'<a href="' + item.url +'">' +
             '<strong class="price">' + Shopify.formatMoney(item.line_price, $cart.data('money-format')) + '</strong>' +
             '</a>' +
             '</li>';*/
        });
		
		
		cart_items_html += '<div class="totals_wrapper"><div class="subtotal"> <span>Sub Total</span>' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</div>' +
			 '<div class="border_btn"><input type="submit" value="Check Out" class="action_button right"></div></div>';
		
        $(".cart-button").addClass('itemincart');
        
        $(".cart-button").html('<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">(' +cart.item_count+ ')</a>');
          
        $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));  

        $cart.html(cart_items_html);
        //$cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');
     
          if($('.currencies:visible option:selected').val()) {
            Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val()); 
          }
		
        $(".cart-ajax-loader").show();
        
        setTimeout(function() {
          $(".cart-ajax-loader").hide();
        }, 199);
        
        
		
		$("#added-box-wrapper").delay(1000).addClass("open-bag");
        $("body").delay(1000).addClass('slideleft_body');
        setTimeout(function() {
          $("#added-box-wrapper").delay(2000).removeClass("open-bag");
          $("body").delay(2000).removeClass('slideleft_body');
        }, 3000);
        $("#body_overlay").addClass("showoverlay");
        //alert('1');
        
		//$("#Prod_added_suc").html('added!');
        //$("body").addClass('slideleft_body');
        $("#Prod_added_suc").fadeIn(800);
        $("#Prod_added_suc").delay(3000).fadeOut(800); 
        $(".addbag_count").show();
        
      }
    }
  }  
  
function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }} 	
	
function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
  ajaxSubmitCart();
}	
	
  
$(document).on("change", "#cart input", function() { 
  	//alert('1');
    ajaxSubmitCart();
});  
  
$(document).on("click", ".ss-icon.minus", function() {  
  	var quantity = parseInt($(this).next("input").val()); 
    var qty = quantity ;
    
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    
    if (qty <= 0) {
   		$(this).closest('li.cart_item').addClass('animated fadeOutUp')
      	setTimeout(ajaxSubmitCart, 500);
    } else {
      	ajaxSubmitCart();
      	$("#Prod_added_suc").hide();
    }
  });  

$(document).on("click", ".ss-icon.plus", function() { 
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
    ajaxSubmitCart();
  	$("#Prod_added_suc").hide();
  });
  

$(document).on("submit",".product_form", function(e) { 
      e.preventDefault();
      var $addToCartForm = $(this);  
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
		
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function(itemData) { 
    	  $.getJSON("/cart.js", function(cart) { 
            refreshCart(cart);
            window.setTimeout(function(){ $('.cart-button').click(); }, 500);
          });    
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          //var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartBtn.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Basket").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
});

$(document).ready(function(){
//bag card click to show close icon olny
 $('.cart-count').click(function(){
    $("body").addClass('slideleft_body');
   	$("#added-box-wrapper").addClass("open-bag");
   	$(".box_patch").fadeIn();
   	
 }); 
  
 $('.box_patch').click(function(){
    $("#added-box-wrapper").removeClass("open-bag");
   	$(".box_patch").fadeOut();
    $("body").removeClass('slideleft_body');
 });  
  
});